import React from 'react';
// styles
import styled, { css } from 'styled-components';
// state
import { useSoFormStepsState } from '../../SoForm.context';
import SoFormContainer from './SoFormContainer';
import SoFormStepConfiguration from '../../steps/configuration/SoFormStepConfiguration';
import {
  ConfigurationIcon,
  PriceIcon,
  ComplementsIcon,
  ConfirmationIcon,
} from 'refactored/ui/icons';
import SoFormStepConfirmation from '../../steps/confirmation/SoFormStepConfirmation';
import SoFormStepComplements from '../../steps/complements/SoFormStepComplements';
import SoFormStepPrice from '../../steps/price/SoFormStepPrice';
import SoFormHeaderButton from './SoFormHeaderButton';
import { useTranslation } from 'react-i18next';

const SoFormHeaderButtonsContainer = styled.div`
  gap: 4px;
  display: flex;
`;

const SoFormHeader = ({ className }) => {
  const { t } = useTranslation('Catalog');
  const stepsState = useSoFormStepsState();
  const currentStep = stepsState.currentStep;
  if (!!currentStep.hideHeader) return <></>;

  const steps = [
    {
      value: SoFormStepConfiguration.nameForData,
      text: t('header.configuration'),
      icon: <ConfigurationIcon />,
      isSelected:
        currentStep.nameForData === SoFormStepConfiguration.nameForData,
    },
    {
      value: SoFormStepPrice.nameForData,
      text: t('header.price'),
      icon: <PriceIcon />,
      isSelected: currentStep.nameForData === SoFormStepPrice.nameForData,
    },
    {
      value: SoFormStepComplements.nameForData,
      text: t('header.complements'),
      icon: <ComplementsIcon />,
      isSelected: currentStep.nameForData === SoFormStepComplements.nameForData,
    },
    {
      value: SoFormStepConfirmation.nameForData,
      text: t('header.confirmation'),
      icon: <ConfirmationIcon />,
      isSelected:
        currentStep.nameForData === SoFormStepConfirmation.nameForData,
    },
  ];

  return (
    <div className={className}>
      <SoFormContainer>
        <SoFormHeaderButtonsContainer>
          {steps.map((step) => (
            <SoFormHeaderButton step={step} key={step.value} />
          ))}
        </SoFormHeaderButtonsContainer>
      </SoFormContainer>
    </div>
  );
};

const regularCSS = css`
  background: var(--white);
  width: 100%;
  display: flex;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
`;

export default styled(SoFormHeader)`
  ${regularCSS}
`;
